import { resolveEstateRegion } from '@internal/azure-regions';

interface ErrorSink {
  addError: (message: string) => void;
}

// Refuses, before submission, a region the spoke generator would refuse:
// one outside the estate, or one whose table entry still has a gap.
export const validateRegion = (
  value: string | undefined,
  validation: ErrorSink,
): void => {
  if (!value) return;
  try {
    resolveEstateRegion(value);
  } catch (error) {
    validation.addError((error as Error).message);
  }
};
